import React from "react";

const Logo = () => {
  return (
    <div className="cursor-pointer font-semibold">
      <h1>Crypto Board</h1>
    </div>
  );
};

export default Logo;
